import React from "react";
import { observer } from "mobx-react-lite";
import { Grid } from "@telefonica/mistica";
import { TextListItem } from "../TextListItem";
import { formatAmount, formatPercentage } from "../../utils/formatters";
import { strings } from "../../localization";

interface IProps {
	blockedValue: number;
	contractFees: number;
	IOF: number;
	CET: number;
	yearsFees: number;
	yearsAdvance: number;
	tacAmount: number;
}

export const AnticipationDetails: React.FC<IProps> = observer((props) => {
	const { blockedValue, contractFees, IOF, CET, yearsFees, yearsAdvance, tacAmount } = props;
	const { year } = strings.components.anticipationSimulation;

	const { fields, helpText, helpTacAmount } = strings.components.ContractValuesDetails;
	return (
		<Grid gap={16}>
			<TextListItem name={fields.blockedValue} description={formatAmount(blockedValue)} tooltipText={helpText} />
			<TextListItem name={fields.contractFees} description={formatAmount(contractFees)} />
			<TextListItem name={fields.iof} description={formatAmount(IOF)} />
			<TextListItem name={fields.cet} description={formatPercentage(CET)} />
			<TextListItem name={fields.yearFees} description={formatPercentage(yearsFees) + " a.a"} />
			<TextListItem name={fields.tacAmount} description={formatAmount(tacAmount)} tooltipText={helpTacAmount} />
			<TextListItem name={fields.yearsAdvance} description={`${yearsAdvance} ${year(yearsAdvance)}`} />
		</Grid>
	);
});
